import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import PayinsForTable from '../../../../objects/PayinsForTable';

import CurrencyUtils from 'PMT/utils/CurrencyUtils';

export default class PayinsTableViewRow extends Component {

  static propTypes = {
    onToggleDetail: PropTypes.func.isRequired,
    payinsForTable: PropTypes.instanceOf(PayinsForTable).isRequired,
    detailIsDisplay: PropTypes.bool.isRequired,
    currencyCode: PropTypes.string,

  };

  constructor() {
    super();

    // bind functions
    this._toggleDetail = this._toggleDetail.bind(this);
  }

  _toggleDetail() {
    this.props.onToggleDetail(this.props.payinsForTable);
  }

  renderIconZoom() {
    if (this.props.detailIsDisplay) {
      return (<i className="glyphicon glyphicon-zoom-out" />);
    }
    return (<i className="glyphicon glyphicon-zoom-in" />);
  }

  render(): Object {
    const payinsForTable:PayinsForTable = this.props.payinsForTable;
    const currencyCode = this.props.currencyCode;

    let iconZoomView = this.renderIconZoom();

    return (
      <tr>
        <td>{payinsForTable.getFormattedDate()}</td>
        <td>{payinsForTable.getFormattedHour()}</td>
        <td className="text-right">
          {CurrencyUtils.formatPriceWithCurrency(payinsForTable.totalTable,
              currencyCode)}
        </td>
        <td className="text-right">
          {CurrencyUtils.formatPriceWithCurrency(payinsForTable.amount,
              currencyCode)}
        </td>
        <td className="text-right">
          {payinsForTable.tips > 0 &&
              (<span>{CurrencyUtils.formatPriceWithCurrency(payinsForTable.tips,
                  currencyCode)}</span>)
          }
          { payinsForTable.tips === 0 &&
            (<span className="empty"> - </span>)
          }
        </td>
        <td>
          {payinsForTable.payins.length > 1 &&
            <button
              className="btn btn-link"
              type="button"
              onClick={this._toggleDetail}
            >{iconZoomView}
          </button>
          }
        </td>

      </tr>
    );

  }

}
